import EnhancedButton from '@components/button/EnhancedButton';
import ShowForUser from '@components/common/ShowForUser';
import { IDynamicDiplayView } from '@components/widgets/dynamic-display';
import DynamicWidget from '@components/widgets/dynamic-display/DynamicWidget';
import { IAbstractRecord } from '@models';
import SalesForceBusinessUserDrawer from '@modules/salesforce/business-users/salesforce-business-users-drawer/SalesForceBusinessUserDrawer';
import FormattingService from '@services/FormattingService';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

interface IBusinessUserDetails {
  businessUserStatus: string;
  data: IAbstractRecord;
  onSuccess: () => void;
}

const BusinessUserDetails: React.FC<IBusinessUserDetails> = ({
  businessUserStatus,
  data,
  onSuccess,
}) => {
  const { id: entityId } = useParams<{ id: string }>();
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>();

  const dynamicBusinessUserView: IDynamicDiplayView = {
    name: 'Business User Information',
    sections: [
      {
        name: 'businessUserDetails',
        title: 'Business User Details',
        showActionButtons: true,
        properties: {
          type: {
            value: FormattingService.formatEnumToDisplay(data.typeTitle),
            name: 'type',
            title: 'Type',
            multiline: false,
          },
          account: {
            value: data.account,
            name: 'account',
            title: 'Account',
            multiline: false,
          },
          access: {
            value: data.accessTitle,
            name: 'access',
            title: 'Access',
            multiline: false,
          },
        },
      },
    ],
  };

  return (
    <>
      <DynamicWidget
        hasFourFields
        view={dynamicBusinessUserView}
        actions={
          <ShowForUser allowedRoles={['Insurance-Admin']}>
            {businessUserStatus !== 'inactive' && (
              <EnhancedButton
                type="button"
                isPrimary
                onClick={() => setIsDrawerOpen(true)}
              >
                Modify
              </EnhancedButton>
            )}
          </ShowForUser>
        }
      />
      {isDrawerOpen && (
        <SalesForceBusinessUserDrawer
          open={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          onSuccess={() => {
            setIsDrawerOpen(false);
            onSuccess();
          }}
          businessUserId={entityId}
          salesForceBusinessUserDetailsInfo={data as any}
        />
      )}
    </>
  );
};

export default BusinessUserDetails;
